import { FETCH_ALL_CUSTOM_FIELDS_SUCCESS } from '../types'

export default function isLoading(state = false, { type }) {
  if (type === FETCH_ALL_CUSTOM_FIELDS_SUCCESS) return true
  return state
}
